import { render, staticRenderFns } from "./ComplexParameter.vue?vue&type=template&id=db87409a&"
import script from "./ComplexParameter.vue?vue&type=script&lang=ts&"
export * from "./ComplexParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports